define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/locale",
	"csi/xml",
	"csi/action/Controller",
	"csi/widget/MessageDialog"
], function(array,declare,lang,locale,xml,Controller,MessageDialog) {

	return declare(Controller, {
		_resetOperation: null, // subclass must specify this
		_refreshOperation: null, // subclass must specify this
		_mustUseLatest: true,

		toWriterRequest: function() {
			return this.inherited(arguments).addParameter("MustUseLatest", xml.ATTR_BOOLEAN, this._mustUseLatest);
		},

		_onPublishError: function(/*Error*/err) {
			if (err.csiErrorCode.match(/COST_ITEM_NOT_LATEST_SOURCE_REVISION$/)) {
				this._promptForReset();
			} else {
				this.inherited(arguments);
			}
		},

		_afterPromptForReset: function(/*String*/key) {
			if (key == MessageDialog.BUTTON_CANCEL) {
				this.postProcess();
			} else if (key == MessageDialog.BUTTON_CONTINUE) {
				this._mustUseLatest = false;
				this.setProgress();
				Controller.prototype.process.call(this);
			} else if (key == MessageDialog.BUTTON_RESET) {
				this._callOperation(this._resetOperation);
			} else if (key == "Refresh") {
				this._callOperation(this._refreshOperation);
			}
		},

		_callOperation: function(/*String*/operation) {
			this.m_writer.callMethod("CostScenario", operation)
				.addParameter(xml.PROP_URL_PARENT, xml.ATTR_REF, this.m_urlParent);

			this.m_writer.execute({
				load: lang.hitch(this, this._onPublishResponse),
				error: lang.hitch(this, this._onPublishError)
			});
		}
	});
});